import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ConfigService} from "../../../services/webFeeder/config.service";
import {DailyOrderService} from "../../../services/webFeeder/sckt-daily-order.service";
import {Constants} from "../../../utils/constants";
import {Subscription} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {ConnectTypeUperEnum} from "../../../model/enum/connect-type-user.enum";
import {BrokerAuthenticationComponent} from "../../../business/broker-authentication/broker-authentication.component";
import {SystemServiceErrorCodKeyEnum, SystemServiceErrorEnum} from "../../../model/enum/system-services-error-msg";
import {AuthenticationService} from "../../../services/authentication.service";
import {ScktLoginDuplicatedService} from "../../../services/webFeeder/sckt-login-duplicated.service";
import {WhitelabelEnum} from "../../../model/enum/whitelabel.enum";
import {SidebarService} from "../../../services/sidebar.service";
import {AppUtils} from "../../../utils/app.utils";
import {AuthServer} from "../../../services/auth-server.service";
import {ConnectionService} from "ng-connection-service";
import {ContextInfoUser} from "../../../model/webFeeder/context-info-user";
import {AssessorSearchClientComponent} from "../../../business/assessor-search-client/assessor-search-client.component";

@Component({
  selector: 'app-account-negotiation',
  templateUrl: './account-negotiation.component.html',
  styleUrls: ['./account-negotiation.component.scss']
})
export class AccountNegotiationComponent implements OnInit{
  dialog: MatDialog;
  wlConfig = this._configService.getConfigWhitelabel();
  loading = true;
  isFirstLoadingWks = true;
  messageLogout = { title: '', subTitle: '' };
  loadingNews = true;
  todayNewsNotFound = false;
  news: any = [];
  isFirstRequestNews = true;
  intervalRequestNews: any;
  intervalSetRotateNews: any;
  speedRate = 7;
  newsAnimationDuration = 0;
  textOffline = Constants.TEXT_INTERNET_OFFLINE;
  textNewsNotFound = Constants.MSG_NEWS_NOT_FOUND;
  netAnimationDuration = 0;
  @ViewChild('newsContainer') newsContainer: ElementRef<HTMLDivElement>;
  private subscriptionHbLoginType: Subscription;
  model: any = [];
  connectedAs: number;
  isMultiBroker = this._configService.isMultiBroker();
  isUserAssessor = this._configService.isUserAssessorLogged();
  isLoginTypeWSO2 = this._configService.isLoginTypeWSO2();
  brokers: ContextInfoUser = new ContextInfoUser();
  connectTypeUperEnum = ConnectTypeUperEnum;
  changeAccountAssessorModal: boolean;
  public subscriptionDailyOrder: Subscription;
  private clickOpenLoginTab: Subscription;
  private subscriptionSessionExpired: Subscription;
  private changeAccountObservable: Subscription;
  private subscriptionClientAssessorChangeSelect: Subscription;
  sessionExpired: boolean;
  socketConnectOn = true;
  showMessageConnectOn: boolean;
  subscriptionSocketConnectOn: Subscription;
  changeSelectedAccount: any;
  isRanking: boolean;

  constructor(
    dialog: MatDialog,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService,
    private _authenticationService: AuthenticationService,
    private _scktLoginDuplicatedService: ScktLoginDuplicatedService,
    private _sidebarService: SidebarService,
    private _authServer: AuthServer,
    private _connectionService: ConnectionService,


  ) {
    this.dialog = dialog;
    this.messageLogout.title = this.wlConfig.login.messageLogout.title ? this.wlConfig.login.messageLogout.title : Constants.ERROR_SYSTEM_TEXT;
    this.messageLogout.subTitle = this.wlConfig.login.messageLogout.subTitle ? this.wlConfig.login.messageLogout.subTitle : null;
    this.isRanking = this.wlConfig.system.cod === WhitelabelEnum.RANKING;

    this.clickOpenLoginTab = this._sidebarService.clickOpenTabLoginBroker$.subscribe(x => {
      if (x && this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginS) {
        this.openBrokerAuthenticationModal();
      }
    });

    this.changeAccountObservable = this._configService.changeAccountBillet$.subscribe(res => {
      if (res) {
        this.loading = true;
        this.changeAccountAssessorModal = true;
      }
    });

    this.subscriptionClientAssessorChangeSelect = this._configService.clientAssessorChangeSelect$.subscribe(x => {
      if (x) {
        this.loading = true;
        this.loadProfileInit(this.connectedAs);
      }
    });

    this.subscriptionSocketConnectOn = this._connectionService.monitor().subscribe(isConnected => {
      if (isConnected) {
        this._configService.writeLog('', 'HEADER > fromEvent > online: CONEXAO COM INTERNET ONLINE');
        this.showMessageConnectOn = true;
        this.textOffline = Constants.TEXT_INTERNET_ONLINE;
        setTimeout(() => {
          this.socketConnectOn = true;
        }, 7000);
      } else {
        this._configService.writeLog('', 'HEADER > fromEvent > offline: CONEXAO COM INTERNET OFFLINE');
        this.showMessageConnectOn = false;
        this.textOffline = Constants.TEXT_INTERNET_OFFLINE;
        this.socketConnectOn = false;
      }
    });

  }

  ngOnInit() {
    this.subscriptionHbLoginType = this._configService.authHbLoginType$.subscribe(data => {
      this.connectedAs = data;
      if (this._configService.getBrokerAccountType()) {
        this.connectedAs = Number(this._configService.getBrokerAccountType());
      }
      if (this.connectedAs === ConnectTypeUperEnum.HB_TYPE_ERROR) {
        this.loadPerfil();
        return;
      } else if (this.connectedAs === ConnectTypeUperEnum.HB_TYPE_MARKET_DATA) {
        this.model.showOnlyMarketData = true;
        this.loadPerfil();
        return;
      } else {
        this.loadProfileInit(this.connectedAs);
      }
    });
  }

  loadPerfil() {
    switch (this.connectedAs) {
      case ConnectTypeUperEnum.HB_TYPE_ASSESSOR: // 1
        this.model.imageBroker = './assets/images/assets/avatar.svg';
        const user = this._configService.getAssessorClientSelected();
        this.model.clientName = user && user.full_name ? user.full_name.split(' ')[0] : null;
        break;
      case ConnectTypeUperEnum.HB_TYPE_OFFILINE: // 3
        if (this.wlConfig.system.isMultiBroker && this._configService.getConfigMultibroker()) {
          const brokers = this._configService.getConfigMultibroker();
          if (brokers) {
            this.model.brokerName = brokers.usersBrokerName;
            this.model.imageBroker = brokers.usersBrokerImamge;
            this.model.clientName = this.model.selectedAccount ? brokers.usersBrokerName : Constants.BROKER_SIDE_BAR_OFFLINE;
          }
        } else {
          this.model.imageBroker = './assets/images/broker/BROKER_FASTTRADE.png';
          this.model.clientName = Constants.BROKER_SIDE_BAR_OFFLINE;
        }
        this.loading = false;
        break;
      case ConnectTypeUperEnum.HB_TYPE_CEDRO: // 4:
        this.model.clientName = this._configService.getWhiteLabel() === ConnectTypeUperEnum.HB_TYPE_CEDRO ? 'Cedro' : '';
        if (this.isRanking) {
          this.model.imageBroker = './assets/images/broker/BROKER_SIMULADOR.png';
        } else {
          this.model.imageBroker = this._configService.getWhiteLabel() === ConnectTypeUperEnum.HB_TYPE_CEDRO
            ? './assets/images/assets/cedro.png' : './assets/images/broker/BROKER_' + this._configService.getBroker().toUpperCase() + '.png';
        }
        if (this.wlConfig.system.isMultiBroker) {
          this.brokers = this._configService.getConfigMultibroker();
          if (this.brokers) {
            this.model.clientName = this.model.selectedAccount ? this.brokers.usersBrokerName : Constants.BROKER_SIDE_BAR_OFFLINE;
            this.model.imageBroker = this.brokers.usersBrokerImamge;
            this.model.brokerName = this.brokers.usersBrokerName;
          }
        }
        break;
      case ConnectTypeUperEnum.HB_TYPE_SIMULATOR: // 5:
        this.model.clientName = 'SIMULADOR';
        this.model.brokerName = 'SIMULADOR';
        this.model.imageBroker = './assets/images/broker/BROKER_SIMULADOR.png';
        break;
      case ConnectTypeUperEnum.HB_TYPE_MARKET_DATA: // 6:
        if (this.wlConfig && this.wlConfig.system && this.wlConfig.system.enableLoginMarketData) {
          this.model.clientName = Constants.BROKER_SIDE_BAR_MARKET_DATA;
          this.model.imageBroker = './assets/images/svg/logo-market.svg';
          this.dialog.closeAll();
        } else {
          this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.connectedAs, SystemServiceErrorCodKeyEnum.error);
        }
        break;
      default:
        this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
          SystemServiceErrorEnum.connectedAs, SystemServiceErrorCodKeyEnum.error);
        break;
    }
    this.getBrokerSigle();
    this._configService.writeLog('SIDEBAR > loadPerfil() - isFirstLoadingWks: ' + this.isFirstLoadingWks);
    if (this.isFirstLoadingWks || this.connectedAs === ConnectTypeUperEnum.HB_TYPE_MARKET_DATA) {
      this.isFirstLoadingWks = false;
      this._configService._getWksAfterValidateUser.next(true);
    }
    this.loading = false;

  }

  getBrokerAccountList(accountHbLogged?) {
    this.loading = true;
    this._configService.writeLog('SIDEBAR > getBrokerAccountList() - account' + accountHbLogged);
    if (accountHbLogged) {
      this._authServer.iNegotiation.brokerServiceAccountList(accountHbLogged)
        .subscribe(resBroker => {
          this._configService.writeLog(resBroker, 'SIDEBAR > resposta - brokerServiceAccountList');
          if (resBroker && resBroker.length > 0) {
            const getPerfilSuitability = this.wlConfig.sidebar.showProfileSuitabilityName
            && [Constants.LOGIN_TYPE.LoginA, Constants.LOGIN_TYPE.LoginIAM].includes(this.wlConfig.system.login_type as any) ? true : false;
            this._authServer.iSuitabilityService.suitabilityPerfilInformation(getPerfilSuitability)
              .subscribe(resPerfilSuitability => {
                if (getPerfilSuitability && resPerfilSuitability && resPerfilSuitability.length > 0) {
                  this._configService.writeLog(resPerfilSuitability, 'SIDEBAR > suitabilityPerfilInformation');
                  if (resPerfilSuitability && resBroker) {
                    resBroker.forEach(elementBroker => {
                      const perfilTemp = resPerfilSuitability.find(x => x.suitabilityID && elementBroker.suitabilityID && x.suitabilityID === elementBroker.suitabilityID);
                      elementBroker.suitabilityIdName = perfilTemp && perfilTemp.suitabilityName ? perfilTemp.suitabilityName : null;
                    });
                  }
                }
                let accountOptions = [];
                let optionsTemp: any = [];
                if (this.isUserAssessor) {
                  this._configService.setAssessorListClients(resBroker);
                } else {
                  this._configService.setBrokerAccountList(resBroker);
                }
                let account = this._configService.getBrokerAccountSelected();
                if (!account) {
                  const accoundFound = resBroker.find(element => element.account === accountHbLogged);
                  account = (accoundFound && accoundFound.account) ? accoundFound.account : account;
                }
                if (!account) {
                  const accountList = this.isUserAssessor ? resBroker[0].accountsBean : resBroker;
                  if (!accountOptions.includes(accountList[0].account)) {
                    accountOptions = accountList;
                    this.model.accountHbLogged = accountList[0].account || accountList[0];
                    this.model.selectedAccount = this.model.accountHbLogged;
                    if (this.isUserAssessor) {
                      this._configService.setAssessorClientSelected(resBroker[0]);
                      this._configService.setBrokerAccountSelected(this.model.selectedAccount);
                    } else {
                      this._configService.setBrokerAccountSelected(resBroker[0].account);
                    }
                    this.model.clientSelected = resBroker[0];
                    if (this.wlConfig.sidebar.showProfileSuitabilityName) {
                      this.model.validateSuitability = this.model.clientSelected.validateSuitability;
                      if (this.model.validateSuitability) {
                        const suitabilityAccountSelectedTemp = accountList.find(x => !this.isUserAssessor
                          ? x.account === this.model.clientSelected.account : x === this.model.selectedAccount);
                        if (resBroker && this.model.selectedAccount && suitabilityAccountSelectedTemp && this.model.validateSuitability) {
                          this.model.perfilProfile = !this.isLoginTypeWSO2 && !this.isUserAssessor ? suitabilityAccountSelectedTemp.suitabilityIdName : // WSO2: NAO | ASSESSOR: NAO
                            this.isLoginTypeWSO2 && !this.isUserAssessor ? suitabilityAccountSelectedTemp.profileName : // WSO2: SIM | ASSESSOR: NAO
                              this.isLoginTypeWSO2 && this.isUserAssessor ? resBroker[0].profile_name : // WSO2: SIM | ASSESSOR: SIM
                                'NÃO ENCONTRADO'; // DEFAULT
                          this.model.perfilProfile = this.model.perfilProfile ? this.model.perfilProfile.toUpperCase().trim() : 'NÃO ENCONTRADO';
                        }
                      }
                    }
                  }
                  optionsTemp = AppUtils.removeValueDuplicated(accountOptions, 'account');
                } else if (account) {
                  this._configService.writeLog('SIDEBAR > getBrokerAccountList() - Conta (account): ' + account);
                  for (let i = 0; i < resBroker.length; i++) {
                    const accountList = this.isUserAssessor ? resBroker[i].accountsBean : resBroker;
                    if (!accountOptions.includes(accountList)) {
                      for (let x = 0; x < accountList.length; x++) {
                        if (account && !this.isUserAssessor ? (Number(accountList[x].account) === Number(account)) : (Number(accountList[x]) === Number(account))) {
                          if (!accountOptions.includes(!this.isUserAssessor ? accountList[x].account : accountList[x])) {
                            accountOptions = accountList;
                            this.model.accountHbLogged = resBroker[x];
                            this.model.selectedAccount = this.model.accountHbLogged.account;
                            this.model.clientSelected = resBroker[x];
                            if (this.wlConfig.sidebar.showProfileSuitabilityName) {
                              this.model.validateSuitability = this.model.clientSelected.validateSuitability;
                              if (this.model.validateSuitability) {
                                const suitabilityAccountSelectedTemp = accountList.find(x => !this.isUserAssessor
                                  ? (Number(x.account) === Number(this.model.selectedAccount)) : (Number(x) === Number(this.model.selectedAccount)));
                                if (resBroker && this.model.selectedAccount && suitabilityAccountSelectedTemp && this.model.validateSuitability) {
                                  this.model.perfilProfile = !this.isLoginTypeWSO2 && !this.isUserAssessor ? suitabilityAccountSelectedTemp.suitabilityIdName : // WSO2: NAO | ASSESSOR: NAO
                                    this.isLoginTypeWSO2 && !this.isUserAssessor ? suitabilityAccountSelectedTemp.profileName : // WSO2: SIM | ASSESSOR: NAO
                                      this.isLoginTypeWSO2 && this.isUserAssessor ? resBroker[x].profile_name : // WSO2: SIM | ASSESSOR: SIM
                                        'NÃO ENCONTRADO'; // DEFAULT
                                  this.model.perfilProfile = this.model.perfilProfile ? this.model.perfilProfile.toUpperCase().trim() : 'NÃO ENCONTRADO';
                                }
                              }
                            }
                            break;
                          }
                        }
                      }
                    }
                  }
                  if (this.isUserAssessor) {
                    this._configService.setAssessorClientSelected(this.model.clientSelected);
                  } else {
                    this._configService.setBrokerAccountSelected(this.model.clientSelected.account);
                  }
                  optionsTemp = AppUtils.removeValueDuplicated(accountOptions, 'account');
                }
                this.model.accountHbLogged = [];
                this.model.accountHbLogged = optionsTemp;
                this._configService.setInfoUserLogged(this.model.clientSelected);
                AppUtils.orderObjectAscNumberBillet(this.model.accountHbLogged, !this.isUserAssessor ? 'account' : null);
                this._configService._authHbLogged.next(true);
                this.loadPerfil();
                if (this.changeAccountAssessorModal) {
                  this.showNotificationAccountAssessorModal(this.model.selectedAccount);
                }
                this._configService.writeLog('SIDEBAR > getBrokerAccountList() - brokerServiceAccountList() - selectedAccount: '
                  + (this.isUserAssessor ? this.model.selectedAccount : this.model.selectedAccount) + ' - Perfil: ' + this.model.perfilProfile);
                this.loading = false;
                setTimeout(() => {
                  if (this.model.selectedAccount) {
                    this.subscribeDailyOrder(this.model.selectedAccount);
                  }
                }, 1000);
              });
          } else if (resBroker && resBroker.length === 0 && this.wlConfig && this.wlConfig.system && this.wlConfig.system.enableLoginMarketData) { // MODO OFFLINE
            const typeLoginHB = Constants.COOKIE_HB_TYPE_MARKET_DATA;
            this._configService.setBrokerAccount('[]', typeLoginHB);
            this._configService._authHbLoginType.next(Number(typeLoginHB));
            this.model.showOnlyMarketData = true;
          } else {
            this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
              SystemServiceErrorEnum.brokerServiceAccountList, SystemServiceErrorCodKeyEnum.empty);
          }
        }, error => {
          this._configService.writeLog(error, 'SIDEBAR > resposta - brokerServiceAccountList - Conta não encontrada!');
          if (error.status === 401 || error.status === 110) {
            this._configService.writeLog(null, 'SIDEBAR > errorCode: ' + error.status + ' - URL: ' + error.url);
            this._configService._authHbLoginType.next(3);
            this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
              SystemServiceErrorEnum.brokerServiceAccountList, SystemServiceErrorCodKeyEnum.unautorized);
          }
        });
    } else {
      this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
        SystemServiceErrorEnum.brokerServiceAccountList, SystemServiceErrorCodKeyEnum.empty);
    }
  }

  loadProfileInit(connectedAs: number) {
    switch (connectedAs) {
      case ConnectTypeUperEnum.HB_TYPE_ASSESSOR: // 1 - Assessor WSO2
        const accountSelected = this._configService.getBrokerAccountSelected();
        this.getBrokerAccountList(accountSelected);
        break;
      case ConnectTypeUperEnum.HB_TYPE_OFFILINE: // 3 - Simulador - Offline
        this._configService._authHbLogged.next(false);
        this.loadPerfil();
        break;
      case ConnectTypeUperEnum.HB_TYPE_CEDRO: // 4 - LoginO
        this.model.accountHbLogged = this.wlConfig.system.isMultiBroker || [Constants.LOGIN_TYPE.LoginA, Constants.LOGIN_TYPE.LoginIAM].includes(this.wlConfig.system.login_type as any)
          ? this._configService.getHbAccount() : this._configService.getUserAccountLogged();
        if (this.model.accountHbLogged) {
          this._configService.writeLog('SIDEBAR > loadProfileInit() - accountHbLogged: ' + this.model.accountHbLogged);
          this.getBrokerAccountList(this.model.accountHbLogged);
        } else {
          this.setLoginMarketData();
        }
        break;
      case ConnectTypeUperEnum.HB_TYPE_SIMULATOR: // 5 - Simulador - Online
        this.model.accountHbLogged = this._configService.getBrokerAccount();
        if (this.model.accountHbLogged) {
          this._configService.writeLog('SIDEBAR > loadProfileInit() - accountHbLogged: ' + this.model.accountHbLogged);
          this.getBrokerAccountList(this.model.accountHbLogged);
        } else {
          this.setLoginMarketData();
        }
        break;
      case ConnectTypeUperEnum.HB_TYPE_MARKET_DATA: // 6 = Market Data
        this.setLoginMarketData();
        break;
      default:
        this.setLoginMarketData();
        break;
    }
  }

  changeAccount() {
    const accountOld = this.model && this.model.clientSelected && this.model.clientSelected.account ? this.model.clientSelected.account : null;
    if (this.model.selectedAccount === 'changeBroker') {
      setTimeout(() => {
        this.model.selectedAccount = accountOld;
      }, 0);
      this.openBrokerAuthenticationModal();
    } else if (this.model.selectedAccount === 'sair' || this.sessionExpired) {
      this.loading = true;

      this.model.accountHbLogged = [];
      this.logoutBrokerHB();
      this.model.selectedAccount = null;
      this.model.clientSelected = null;
      this.model.accountHbLogged = [];
      this.model.brokerSigle = null;
      this._configService.setRefreshSnapDaily('true');
      this._configService._resetNumberSnapDaily.next(true);
      this.loading = false;
    } else {
      const brokerAccountTemp: any = this._configService.getBrokerAccountList();
      const suitabilityAccountSelectedTemp = brokerAccountTemp.find(x => x.account === this.model.selectedAccount);
      if (suitabilityAccountSelectedTemp) {
        const oldAccount = this._configService.getBrokerAccountSelected();
        this._dailyOrderService.unsubscribeDailyOrder(oldAccount, Constants.WINDOW_NAME_SIDE_BAR, true);
        this.model.perfilProfile = null;
        this.model.brokerSigle = null;
        this._configService.setRefreshSnapDaily('true');
        this._configService._resetNumberSnapDaily.next(true);
        this._configService.setInfoUserLogged(suitabilityAccountSelectedTemp);
        this._configService.setBrokerAccountSelected(this.model.selectedAccount, true);
        this._configService.setBrokerAccountSelectedTransition(this.model.selectedAccount);
        this.model.validateSuitability = suitabilityAccountSelectedTemp.validateSuitability;
        this.model.clientSelected = suitabilityAccountSelectedTemp;
        if (brokerAccountTemp && this.model.selectedAccount && suitabilityAccountSelectedTemp && this.model.validateSuitability) {
          if (!this.isLoginTypeWSO2 && !this.isUserAssessor) {  // WSO2: NAO
            this.model.perfilProfile = suitabilityAccountSelectedTemp.suitabilityIdName
              ? suitabilityAccountSelectedTemp.suitabilityIdName.toUpperCase().trim()
              : suitabilityAccountSelectedTemp.suitabilityID;
          } else { // WSO2: SIM
            if (this.isLoginTypeWSO2 && !this.isUserAssessor) {
              this.model.perfilProfile = suitabilityAccountSelectedTemp.profileName
                ? suitabilityAccountSelectedTemp.profileName.toUpperCase().trim()
                : suitabilityAccountSelectedTemp.suitabilityID;
            } else {
              this.model.perfilProfile = 'NÃO ENCONTRADO'; // DEFAULT
            }
          }
        }
        this._configService.writeLog('SIDEBAR > changeAccount: ' + this.model.selectedAccount + (this.model.perfilProfile ? ' - Perfil: ' + this.model.perfilProfile : ''));
        this.subscribeDailyOrder(this.model.selectedAccount);
        this.loading = false;
      } else {
        this.loading = false;
        this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.warn);
        setTimeout(() => {
          this.model.selectedAccount = accountOld;
        }, 0);
        return false;
      }
      this.getBrokerSigle();
      this.loading = false;
    }
  }

  subscribeDailyOrder(account) {
    if (account) {
      this.subscriptionDailyOrder = this._dailyOrderService.subscribeDailyOrder(account, Constants.WINDOW_NAME_SIDE_BAR).subscribe();
      this._dailyOrderService.messagesDailyOrder.subscribe();
    }
  }

  getBrokerSigle() {
    if (this.model && this.model.clientSelected && this.model.clientSelected) {
      if (this.isUserAssessor && this.model.clientSelected.full_name && this.model.clientSelected.full_name.split(' ').length > 1) {
        this.model.brokerSigle = this.model.clientSelected.full_name.split(' ')[0].substring(0, 1) + this.model.clientSelected.full_name.split(' ')[1].substring(0, 1);
      } else if (this.model.clientSelected.accountDesc && this.model.clientSelected.accountDesc.split(' ').length > 1) {
        this.model.brokerSigle = this.model.clientSelected.accountDesc.split(' ')[0].substring(0, 1) + this.model.clientSelected.accountDesc.split(' ')[1].substring(0, 1);
      }
    }
  }

  openBrokerAuthenticationModal() {
    if (this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginS) {
      if (this.connectedAs === ConnectTypeUperEnum.HB_TYPE_SIMULATOR || this.connectedAs === ConnectTypeUperEnum.HB_TYPE_OFFILINE
        || this.wlConfig.system.isMultiBroker) {
        this.closeAllModal();
        if (this.dialog) {
          this.dialog.open(BrokerAuthenticationComponent, {
            panelClass: Constants.FULL_MODAL,
            position: { left: '0' },
            width: '555px',
            autoFocus: false,
            disableClose: true
          });
        }
      }
    } else {
      this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
        SystemServiceErrorEnum.connectedAs, SystemServiceErrorCodKeyEnum.error);
    }
  }

  closeAllModal() {
    this._configService._modalBuySellClosed.next(true);
    this.dialog.closeAll();
  }

  redirectExpireSession(title: string, subtitle: string, service?, codKey?) {
    this._configService.redirectExpireSession(title, subtitle, service, codKey);
    return false;
  }

  logoutBrokerHB() {
    if (this.sessionExpired) {
      this.messageLogout.title = Constants.ERROR_EXPIRED_TITLE;
      this.messageLogout.subTitle = Constants.ERROR_EXPIRED_TEXT;
    }
    if (this.model && this.model.clientSelected && this.model.clientSelected.account) {
      if (this.subscriptionDailyOrder && this.model.clientSelected.account) {
        this._dailyOrderService.unsubscribeDailyOrder(this.model.clientSelected.account, Constants.WINDOW_NAME_SIDE_BAR, true);
      }
      this._authenticationService.brokerServiceInternalLogout()
        .subscribe((data: any) => {
          if (this.isLoginTypeWSO2) {
            this.closeAllModal();
            this._authenticationService.logout();
            this._configService.REDIRECT_LOGOUT();
            this._configService._authHbLoginType.next(3);
            this._configService._authHbLogged.next(false);
          } else if (data.error === false || data.error === 'false') {
            this.closeAllModal();
            this._authenticationService.logout();
            this._configService.REDIRECT_LOGOUT();
          } else if (data && (data.isAuthenticated === 'N' && data.text === 'Logout has been successfull.')) {
            this._configService.deleteHbBrokerUser();
            this._configService.setBrokerAccount('[]', Constants.COOKIE_HB_TYPE_OFFILINE);
            this._configService._authHbLoginType.next(Number(Constants.COOKIE_HB_TYPE_OFFILINE));
            this._configService._authHbLogged.next(false);
            this.model.selectedAccount = '';
            if (!this.sessionExpired) {
              this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG020, Constants.ALERT_TYPE.warn);
            }
            if (this.wlConfig.system.login_type === Constants.LOGIN_O || this.sessionExpired) {
              this.closeAllModal();
              this._authenticationService.logout();
              this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle);
            }
          } else {
            this._configService._authHbLogged.next(false);
          }
          this.sessionExpired = false;
          this._configService._loggoutSessionExpired.next(false);
        }, () => {
          this.sessionExpired = false;
          this._configService._authHbLogged.next(false);
          this._configService._loggoutSessionExpired.next(false);
        });
      this._scktLoginDuplicatedService._authLoginDuplicated.next(3);
    } else {
      this._authenticationService.logout();
      this.sessionExpired = false;
      this._configService._loggoutSessionExpired.next(false);
      this.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle);
    }
  }

  showNotificationAccountAssessorModal(value) {
    if (value) {
      if (!this.isUserAssessor) {
        this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG039, Constants.ALERT_TYPE.success);
      } else {
        this._configService.systemNotificationMessage('', 'Conta ' + (value.toString().toUpperCase()) + ' selecionada!', Constants.ALERT_TYPE.success);
      }
      this.changeAccountAssessorModal = false;
    }
  }

  setLoginMarketData() {
    this._configService.setBrokerAccount('[]', Constants.COOKIE_HB_TYPE_MARKET_DATA);
    this.model.showOnlyMarketData = true;
    this.connectedAs = Number(this._configService.getBrokerAccountType());
    this.loadPerfil();
  }

  openAssessorSearch() {
    if (this.isUserAssessor && this.dialog) {
      this.dialog.open(AssessorSearchClientComponent, {
        position: { left: '15px', top: '64px' },
        height: 'calc(100% - 83px)',
        width: 'calc(100% - 30px)',
        maxWidth: 'unset'
      });
    }
  }

}
